import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=7582ed83&scoped=true"
import script from "./Contatos.vue?vue&type=script&lang=js"
export * from "./Contatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7582ed83",
  null
  
)

export default component.exports